import {assertAndContinue} from 'Asserts';

import DataTestAttrs, {DataTestPropName, DataTestProps} from './shared/DataTestAttrs';

/**
 * getTestProps converts DataTestAttrs to the HTML friendly kebab-case.
 *
 * Keep this function in sync with browser-tests/cypress/utils/getTestProps.ts:getTestProps
 */
export default function getTestProps(attrs: Partial<DataTestAttrs> = {}): DataTestProps {
  const {component, element, key, index, ...rest} = attrs;

  assertAndContinue(
    Object.keys(rest).length === 0,
    `Encountered unexpected DataTestAttrs field(s): ${Object.keys(rest).join(', ')}`
  );

  assertAndContinue(
    Object.keys(attrs).filter((key) => key != null).length !== 1,
    `Must specify at least two data test attributes. Only specified: ${Object.keys(attrs).join(', ')}`
  );

  const props: DataTestProps = {
    [DataTestPropName.COMPONENT]: component,
    [DataTestPropName.ELEMENT]: element,
    [DataTestPropName.KEY]: key,
    [DataTestPropName.INDEX]: index,
  };

  return Object.keys(props)
    .filter((key: keyof DataTestProps) => props[key] != null)
    .reduce((obj, key: keyof DataTestProps) => {
      obj[key] = props[key];
      return obj;
    }, {} as DataTestProps);
}
